import { parseISO } from 'date-fns';

import {
  StateAvailabilityGraphql,
  StateAvailability,
  ClinicScheduleSuggestion,
  ClinicScheduleSuggestionGraphql,
} from 'src/dropInClinic/types';

export const deserializeAvailabilityGraphql = (
  rawAvailability: StateAvailabilityGraphql[],
): Record<string, StateAvailability> => {
  const stateAvailability: Record<string, StateAvailability> = {};

  rawAvailability.forEach(item => {
    const {
      overview: overviewGraphql,
      providerAvailability: providerAvailabiltyGraphql,
      state,
    } = item;

    const overview = {
      windows: overviewGraphql.windows.map(({ start, end }) => ({
        start: parseISO(start),
        end: parseISO(end),
      })),
      hasAvailability: overviewGraphql.hasAvailability,
    };

    const providerAvailability = providerAvailabiltyGraphql.map(({ availability, ...rest }) => ({
      availability: { start: parseISO(availability.start), end: parseISO(availability.end) },
      ...rest,
    }));

    stateAvailability[state] = { overview, providerAvailability };
  });

  return stateAvailability;
};

export const deserializeSuggestedSchedule = (
  suggestions: ClinicScheduleSuggestionGraphql[],
): ClinicScheduleSuggestion[] =>
  suggestions.map(({ startTime, ...rest }) => ({ startTime: parseISO(startTime), ...rest }));
